import type { FeedItemType } from '@/types';

export const getTitle = (result: FeedItemType): string => {
  if (result.title && result.title.length > 0) return result.title;
  if (result.extracted_title && result.extracted_title.length > 0)
    return result.extracted_title;
  if (result.newssub && result.newssub.length > 0) return result.newssub;
  if (result.categories && result.categories.length > 0)
    return result.categories;
  if (result.body && result.body.length > 0) return result.body;

  return '';
};
